import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mb-embed-code',
  templateUrl: './embed-code.component.html',
  styleUrls: ['./embed-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbedCodeComponent {
  public embedCode!: string;
  @Input()
  set streamCardId(streamId: string) {
    this.embedCode = `<iframe width="1280" height="720" src="${
      environment.embedUrl
    }?v=${streamId}" frameborder="0" scrolling="no" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
  }
  public copied = false;

  constructor() {}
}
